import { createSlice } from '@reduxjs/toolkit';

export const fundDistributionSlice = createSlice({
    name: 'fundDistribution',
    initialState: {
        dataToAction: { investmentType: '', urlVideo: '', amountToInvest: '', participationValuation: '', investmentDate: '' }
    },
    reducers: {
        selectFundDistribution: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectFundDistribution: (state) => {
            state.dataToAction = { investmentType: '', urlVideo: '', amountToInvest: '', participationValuation: '', investmentDate: '' }
        }
    }
});

export const { selectFundDistribution, unSelectFundDistribution } = fundDistributionSlice.actions;